<template>
  <div>
    <PerfectScrollbar class="AllPwaMobile">
      <div class="AllSiteHeaderMenu">
        <div class="MenuAllSiteHeaderMenuDeposit">
          <div class="ChildSelectTab">
            <!-- <div class="TabChildSelectTab">
              <vs-radio color="#BB86FC" v-model="radios1" vs-name="radios1" vs-value="rial">{{ $t('walletManagement.currencyType.rial') }}</vs-radio>
            </div> -->

            <div class="TabChildSelectTab">
              <vs-radio color="#BB86FC" v-model="radios1" vs-name="radios1" vs-value="dollar">{{ $t('walletManagement.currencyType.dollar') }}</vs-radio>
            </div>
          </div>
        </div>
      </div>

      <div v-if="radios1 == 'dollar'">
        <div class="WalletAllPwaMobile">
          <VsxIcon @click="ShowBtnModel" iconName="AddSquare" :size="32" :color="color" type="linear" />

          <p>{{ $t('walletManagement.wallet') }}</p>
        </div>
      
        <div class="TableModelShowIconToUserSpan1">
          <div class="TopShiwRowModel">
            <div class="ChildTopShiwRowModel">{{ $t('walletManagement.settings') }}</div>
            <div class="ChildTopShiwRowModel">{{ $t('walletManagement.network') }}</div>
            <div class="ChildTopShiwRowModel">{{ $t('walletManagement.walletAddress') }}</div>
            <div class="ChildTopShiwRowModel">{{ $t('walletManagement.wallet') }}</div>
          </div>

          <div v-if="isLoading" class="loading-container">
            <div class="loader"></div>
          </div>

          <div v-else v-for="(typeList, index) in listResponse" :key="index" class="TopShiwRowModel">
            <div style="display: grid; justify-content: center; grid-gap: 10px; grid-template-columns: auto auto; align-items: center" class="ChildTopShiwRowModel1">
              <div @click="deleteBtn(typeList)" class="BtnEditC">{{ $t('walletManagement.actions.delete') }}</div>
              <div @click="openEditModel(typeList)" style="background: #D8B9FF" class="BtnEditC">{{ $t('walletManagement.actions.edit') }}</div>
            </div>
            <div class="ChildTopShiwRowModel1">{{typeList.network}}</div>
            <div class="ChildTopShiwRowModel1">{{typeList.address}}</div>
            <div class="ChildTopShiwRowModel1">{{typeList.name}}</div>
          </div>

        </div>
      </div>

      <div v-if="radios1 == 'rial'">
        <div class="WalletAllPwaMobile">
          <VsxIcon @click="ShowBtnModel" iconName="AddSquare" :size="32" :color="color" type="linear" />

          <p>{{ $t('walletManagement.bankAccounts') }}</p>
        </div>
     
        <div  class="TableModelShowIconToUserSpan1">
          <div class="TopShiwRowModel">
            <div class="ChildTopShiwRowModel">{{ $t('walletManagement.settings') }}</div>
            <div class="ChildTopShiwRowModel">{{ $t('walletManagement.cardNumber') }}</div>
            <div class="ChildTopShiwRowModel">{{ $t('walletManagement.ibanNumber') }}</div>
            <div class="ChildTopShiwRowModel">{{ $t('walletManagement.bank') }}</div>
          </div>

          <div v-if="isLoading" class="loading-container">
            <div class="loader"></div>
          </div>

          <div v-else v-for="(typeList, index) in myBank" :key="index" class="TopShiwRowModel">
            <div style="display: grid; justify-content: center; grid-gap: 10px; grid-template-columns: auto auto; align-items: center" class="ChildTopShiwRowModel1">
              <div @click="deleteBtn(typeList)" class="BtnEditC">{{ $t('walletManagement.actions.delete') }}</div>
              <div @click="openEditModel(typeList)" style="background: #D8B9FF" class="BtnEditC">{{ $t('walletManagement.actions.edit') }}</div>
            </div>
            <div style="padding-top: 8px" class="ChildTopShiwRowModel1">
              <VsxIcon @click="FunClick(typeList.card_number)" iconName="Eye" :size="32" :color="color" type="linear" />
            </div>
            <div style="padding-top: 8px" class="ChildTopShiwRowModel1">
              <VsxIcon @click="FunClick(typeList.shaba_number)" iconName="Eye" :size="32" :color="color" type="linear" />
            </div>
            <div class="ChildTopShiwRowModel1">{{typeList.bank}}</div>
          </div>
        </div>
      </div>

      <div @click="modelShow = false" v-if="modelShow" class="ModelShowIconToUserSpan">
        <div @click.stop class="TableModelShowIconToUserSpan2">
          <form>
            <h1>{{ $t('walletManagement.form.title') }}</h1>
            <div class="ShowLogoInputAndLAbel">
              <label v-if="radios1 == 'dollar'">{{ $t('walletManagement.form.walletName') }}</label>
              <label v-if="radios1 == 'rial'">{{ $t('walletManagement.bank') }}</label>

              <div class="ShowAllNavBarStatus">
                <input v-if="radios1 == 'dollar'" v-model="name" autocomplete="off" type="text" name="name">

                <multiselect v-if="radios1 == 'rial'" placeholder="انتخاب کنید" v-model="value2" :options="option2" label="name" track-by="name"></multiselect>
              </div>

            </div>
            <div class="ShowLogoInputAndLAbel">
              <label v-if="radios1 == 'dollar'">{{ $t('walletManagement.walletAddress') }}</label>
              <label v-if="radios1 == 'rial'">{{ $t('walletManagement.ibanNumber') }}</label>

              <div class="ShowAllNavBarStatus">
                <input autocomplete="off"  v-model="address" type="text" name="username">
              </div>

            </div>
            <div class="ShowLogoInputAndLAbel">
              <label v-if="radios1 == 'dollar'">{{ $t('walletManagement.network') }}</label>
              <label v-if="radios1 == 'rial'">{{ $t('walletManagement.cardNumber') }}</label>

              <div class="ShowAllNavBarStatus">
                <input autocomplete="off"  v-model="network" type="text" name="username">
              </div>

            </div>

            <div @click="CreateWallet" :class="{'ShowLogoInputAndLAbel23': true, 'disabled': isSubmitting}" :disabled="isSubmitting">
              <div v-if="isSubmitting" class="spinner"></div>
              <span v-else>{{ $t('walletManagement.actions.submit') }}</span>
            </div>
          </form>
        </div>
      </div>
      <div @click="modelShowE = false" v-if="modelShowE" class="ModelShowIconToUserSpan">
        <div @click.stop class="TableModelShowIconToUserSpan2">
          <form>
            <h1>ویرایش کیف پول</h1>
            <div class="ShowLogoInputAndLAbel">
              <label v-if="radios1 == 'dollar'"> نام کیف پول </label>
              <label v-if="radios1 == 'rial'"> بانک </label>

              <div class="ShowAllNavBarStatus">
                <input v-if="radios1 == 'dollar'" v-model="nameE" autocomplete="off" type="text" name="name">

                <multiselect v-if="radios1 == 'rial'" placeholder="انتخاب کنید" v-model="value2" :options="option2" label="name" track-by="name"></multiselect>
              </div>

            </div>
            <div class="ShowLogoInputAndLAbel">
              <label v-if="radios1 == 'dollar'"> آدرس کیف پول </label>
              <label v-if="radios1 == 'rial'"> شماره شبا </label>

              <div class="ShowAllNavBarStatus">
                <input autocomplete="off"  v-model="addressE" type="text" name="username">
              </div>

            </div>
            <div class="ShowLogoInputAndLAbel">
              <label v-if="radios1 == 'dollar'"> شبکه </label>
              <label v-if="radios1 == 'rial'"> شماره کارت </label>

              <div class="ShowAllNavBarStatus">
                <input autocomplete="off"  v-model="networkE" type="text" name="username">
              </div>

            </div>

            <div @click="btnUpdate" :class="{'ShowLogoInputAndLAbel23': true, 'disabled': isSubmitting}" :disabled="isSubmitting">
              <div v-if="isSubmitting" class="spinner"></div>
              <span v-else>ثبت</span>
            </div>
          </form>
        </div>
      </div>

    </PerfectScrollbar>
  </div>
</template>

<script>
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import axios from "@/axios";
import {toast} from "vue3-toastify";
import Multiselect from "vue-multiselect";

export default {
  name: "walletShow",
  components: {
    PerfectScrollbar,
    Multiselect,
  },
  data(){
    return{
      radios1:'dollar',
      modelShow: false,
      modelShowE: false,
      name: '',
      network: '',
      address: '',
      color: localStorage.getItem('theme') === 'dark' ? '#BB86FC' : '#2E1977',

      nameE: '',
      networkE: '',
      addressE: '',
      siteBank: [],
      myBank: [],
      listResponse: [],
      editList: [],
      isLoading: false,
      isSubmitting: false,

      value2: {name: 'آدرس کیف پول مقصد را انتخاب کنید'},
      option2: [

      ],
    }
  },
  computed: {
    currentLang() {
      return this.$store.state.currentLang;
    },
    theme() {
      return this.$store.state.theme;
    }
  },
  mounted() {
    this.getWallet()
    setInterval(() => {
      this.loadTheme()
    }, 100);
  },
  methods:{
    ShowBtnModel(){
      this.modelShow =! this.modelShow;
      if (this.modelShow) {
        this.name = '';
        this.network = '';
        this.address = '';
      }
    },
    async CreateWallet(){
      if (this.isSubmitting) return;
      
      this.isSubmitting = true;
      const userData = localStorage.getItem('user');
      const userData1 = JSON.parse(userData);

      if(this.radios1 == 'dollar'){
        try {
          const currentLanguage = this.currentLang;
          const response = await axios.post('/create-wallet', {
            user_id: userData1.id,
            name: this.name,
            network: this.network,
            address: this.address,
            language: currentLanguage
          });

          if (response.data[0] == "success"){
            toast(response.data[1], {
              autoClose: 3000,
              position: "top-right",
              type: "success",
            });
            await this.getWallet();
            this.modelShow = false;
            this.name = '';
            this.network = '';
            this.address = '';
          }
        } catch (error) {
          if (error.response) {
            const errors = error.response.data.errors;
            const keys = Object.keys(errors);
            
            // Only show first error to avoid multiple notifications
            if (keys.length > 0) {
              toast(errors[keys[0]][0], {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }
          } else {
            console.error('An unexpected error occurred:', error.message);
            if (error.response && error.response.data && error.response.data[1]) {
              toast(error.response.data[1], {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            } else {
              toast("خطای غیرمنتظره رخ داده است.", {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }
          }
        } finally {
          this.isSubmitting = false;
        }
      }

      if(this.radios1 == 'rial'){
        try {
          const currentLanguage = this.currentLang;
          const response = await axios.post('/create-bank', {
            user_id: userData1.id,
            bank_id: this.value2.value,
            shaba_number: this.address,
            card_number: this.network,
            language: currentLanguage
          });

          if (response.data[0] == "success"){
            toast(response.data[1], {
              autoClose: 3000,
              position: "top-right",
              type: "success",
            });
            await this.getWallet();
            this.modelShow = false;
            this.name = '';
            this.network = '';
            this.address = '';
          }
        } catch (error) {
          if (error.response) {
            const errors = error.response.data.errors;
            const keys = Object.keys(errors);
            
            // Only show first error to avoid multiple notifications
            if (keys.length > 0) {
              toast(errors[keys[0]][0], {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }
          } else {
            console.error('An unexpected error occurred:', error.message);
            if (error.response && error.response.data && error.response.data[1]) {
              toast(error.response.data[1], {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            } else {
              toast("خطای غیرمنتظره رخ داده است.", {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }
          }
        } finally {
          this.isSubmitting = false;
        }
      }
    },
    async getWallet(){
      this.isLoading = true;
      const userData = localStorage.getItem('user');
      const userData1 = JSON.parse(userData);

      try {
        const currentLanguage = this.currentLang;
        const response = await axios.post('/get-wallet', {
          user_id: userData1.id,
          language: currentLanguage
        });

        this.listResponse = response.data[0];
        this.siteBank = response.data[1];
        this.myBank = response.data[2];

        this.option2 = [];
        for (let i = 0; i < response.data[1].length; i++) {
          this.option2.push({ name: response.data[1][i].title, value: response.data[1][i].id, all: response.data[1][i].id });
        }
      } catch (error) {
        console.error('Error fetching wallet data:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async deleteBtn(value){
      const result = await this.$swal({
        title: 'آیا مطمئن هستید؟',
        text: "این عمل قابل بازگشت نیست",
        showCancelButton: true,
        confirmButtonText: 'حذف',
        confirmButtonAriaLabel: "Thumbs up, great!",
        cancelButtonText: 'انصراف',
        cancelButtonAriaLabel: "Thumbs down"
      });

      if (result.value == true) {
        this.isLoading = true;
        const userData = localStorage.getItem('user');
        const userData1 = JSON.parse(userData);

        if(this.radios1 == 'dollar'){
          try {
            const currentLanguage = this.currentLang;
            const responsive = await axios.post('/delete-wallet', {
              user_id: userData1.id,
              wallet_id: value.id,
              language: currentLanguage
            });

            if (responsive.data[0] == "success"){
              await this.getWallet();
              toast(responsive.data[1], {
                autoClose: 3000,
                position: "top-right",
                type: "success",
              });
            }else{
              toast("خطا در حذف کیف پول", {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
              this.isLoading = false;
            }
          } catch (error) {
            console.error('Error deleting wallet:', error);
            if (error.response && error.response.data && error.response.data[1]) {
              toast(error.response.data[1], {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            } else {
              toast("خطا در حذف کیف پول", {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }
            this.isLoading = false;
          }
        }

        if(this.radios1 == 'rial'){
          try {
            const currentLanguage = this.currentLang;
            const responsive = await axios.post('/delete-bank', {
              user_id: userData1.id,
              id: value.id,
              language: currentLanguage
            });

            if (responsive.data[0] == 'success'){
              await this.getWallet();
              toast(responsive.data[1], {
                autoClose: 3000,
                position: "top-right",
                type: "success",
              });
            }else{
              toast("خطا در حذف حساب بانکی", {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
              this.isLoading = false;
            }
          } catch (error) {
            console.error('Error deleting bank account:', error);
            if (error.response && error.response.data && error.response.data[1]) {
              toast(error.response.data[1], {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            } else {
              toast("خطا در حذف حساب بانکی", {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }
            this.isLoading = false;
          }
        }
      }
    },
    async openEditModel(value){
      this.modelShowE =! this.modelShowE;
      if(this.radios1 == 'dollar'){
        this.nameE = value.name;
        this.networkE = value.network;
        this.addressE = value.address;
        this.editList = value;
      }
      if(this.radios1 == 'rial'){
        this.nameE = value.title;
        this.networkE = value.card_number;
        this.addressE = value.shaba_number;
        this.editList = value;
        this.value2 = {name: value.bank, value: value.id, all: value.bank_id};
      }
    },
    async btnUpdate(){
      if (this.isSubmitting) return;
      
      this.isSubmitting = true;
      const userData = localStorage.getItem('user');
      const userData1 = JSON.parse(userData);

      if(this.radios1 == 'dollar'){
        try {
          const currentLanguage = this.currentLang;
          const response = await axios.post('/edit-wallet', {
            user_id: userData1.id,
            id: this.editList.id,
            name: this.nameE,
            network: this.networkE,
            address: this.addressE,
            language: currentLanguage
          });

          if (response.data[0] == "success"){
            toast(response.data[1], {
              autoClose: 3000,
              position: "top-right",
              type: "success",
            });
            await this.getWallet();
            this.modelShowE = false;
          }
        } catch (error) {
          if (error.response) {
            const errors = error.response.data.errors;
            const keys = Object.keys(errors);
            
            // Only show first error to avoid multiple notifications
            if (keys.length > 0) {
              toast(errors[keys[0]][0], {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }
          } else {
            console.error('An unexpected error occurred:', error.message);
            if (error.response && error.response.data && error.response.data[1]) {
              toast(error.response.data[1], {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            } else {
              toast("خطای غیرمنتظره رخ داده است.", {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }
          }
        } finally {
          this.isSubmitting = false;
        }
      }

      if(this.radios1 == 'rial'){
        try {
          const currentLanguage = this.currentLang;
          const response = await axios.post('/edit-bank', {
            user_id: userData1.id,
            id: this.editList.id,
            name: this.value2.name,
            bank_id: this.value2.all,
            shaba_number: this.addressE,
            card_number: this.networkE,
            language: currentLanguage
          });

          if (response.data[0] == 'success'){
            toast(response.data[1], {
              autoClose: 3000,
              position: "top-right",
              type: "success",
            });
            await this.getWallet();
            this.modelShowE = false;
          }
        } catch (error) {
          if (error.response) {
            const errors = error.response.data.errors;
            const keys = Object.keys(errors);
            
            // Only show first error to avoid multiple notifications
            if (keys.length > 0) {
              toast(errors[keys[0]][0], {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }
          } else {
            console.error('An unexpected error occurred:', error.message);
            if (error.response && error.response.data && error.response.data[1]) {
              toast(error.response.data[1], {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            } else {
              toast("خطای غیرمنتظره رخ داده است.", {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }
          }
        } finally {
          this.isSubmitting = false;
        }
      }
    },
    async FunClick(value){
      await this.$swal({
        title: value,
        showCancelButton: false,
      });
    },
    loadTheme() {
      const savedTheme = localStorage.getItem('theme');
      if(savedTheme == "light"){
        this.color = '#2E1977';
      }else{
        this.color = '#BB86FC';
      }
    }
  },
}
</script>

<style scoped>
.ShowLogoInputAndLAbel{
  grid-gap: 10px !important;
}
.ShowAllNavBarStatus input{
  border-radius: 5px !important;
  background: #D3C5FF7A !important;
}
.TopShiwRowModel{
  display: grid;
  grid-template-columns: 25% 25% 25% 25% !important;
}
.MenuAllSiteHeaderMenuDeposit{
  justify-content: center !important;
}
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100px;
}
.loader {
  border: 4px solid rgba(211, 197, 255, 0.3);
  border-radius: 50%;
  border-top: 4px solid #BB86FC;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}
.spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255,255,255,.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.ShowLogoInputAndLAbel23 {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>